// extracted by mini-css-extract-plugin
export default {"vbUiBtn":"VmUqi__vbUiBtn","afterButton":"AAsu8__afterButton","btnSecondary":"Sui55__btnSecondary","btnPrimary":"tYlpQ__btnPrimary"};